import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { Button } from '@miroculus/nucleo';
import styles from './ErrorModalContent.scss';
const cx = classnames.bind(styles);
const ErrorModalContent = memo(({ errorCount, onCancel, onConfirm }) => (React.createElement("div", { className: cx('container') },
    React.createElement("div", { className: cx('titleContainer') },
        React.createElement("h1", { className: cx('title') },
            errorCount,
            " errors")),
    React.createElement("div", { className: cx('mainContainer') },
        React.createElement("div", { className: cx('main') },
            React.createElement("p", { className: cx('explanation') },
                "You have ",
                errorCount > 1 ? 'multiple errors ' : 'an error ',
                "in your protocol.",
                React.createElement("br", null),
                "You can save, but you cannot finish the protocol until you revise",
                errorCount > 1 ? ' these errors' : ' this error',
                "."),
            React.createElement("h1", { className: cx('question') }, "Would you like to review the protocol?"),
            React.createElement("div", { className: cx('buttonsContainer') },
                React.createElement(Button, { flavor: "secondary", onClick: onCancel }, "Ignore"),
                React.createElement(Button, { flavor: "secondary", onClick: onConfirm }, "Yes")))))));
export default ErrorModalContent;
